module.exports = __webpack_public_path__ + "img/sjyy-cwhd-part-one.423e691b.png";